/* eslint-disable no-unused-vars */

import React from 'react'
import styled, { keyframes } from 'styled-components'
import Menu from '../../../components/Menu/Navbar'
import Header from '../../../components/Header/header'
import Logo from '../../../components/Logo/logo'
import Footer from '../../../components/Footer/footer'
import {
  ContainerGeneral,
  TituloGrande,
  ContainerTexto
} from '../../RioGrande/styletexto'
import FxView from '../../../components/FxView/fxview'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFilePdf,
  faDownload,
  faFileLines
} from '@fortawesome/free-solid-svg-icons'


const ContainerImagenes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

const Imagen = styled.img`
  width: 90%;
  max-width: 900px;
  height: auto;
  margin: 10px;
`

const blinkAnimation = keyframes`
  0%, 100% {
    background-color: #000000;
    color: #a0f000;
  }

  50% {
    background-color: #a0f000;
    color: #000000;
  }
`

const Boton = styled.a`
  font-size: 15px;
  width: 90%;
  max-width: 500px;
  font-family: 'Kobern';
  display: inline-block;
  margin-bottom: 16px;
  padding: 15px 20px;
  background-color: #a0f000;
  color: #000000;
  text-align: center;
  border-radius: 5px;
  text-decoration: none;
  animation: ${blinkAnimation} 2s infinite;
  transition: all 0.25s ease;

  &:hover {
    background-color: #000000;
    color: #ffffff;
    transform: translateY(-2px);
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 50px;
`


/* =========================
   DOCUMENTOS
========================= */

const DocumentosSection = styled.div`
  width: 90%;
  max-width: 1000px;
  margin: 30px auto 60px;
`

const DocumentosTitulo = styled.h2`
  color: #ffffff;
  font-family: 'Kobern';
  font-size: 32px;
  font-weight: 400;
  text-align: center;
  margin: 0 0 10px;

  @media (max-width: 600px) {
    font-size: 26px;
  }
`

const DocumentosSubtitulo = styled.p`
  color: #a9a9a9;
  font-family: 'Kobern';
  font-size: 15px;
  text-align: center;
  margin: 0 0 30px;
`

const DocumentosGrid = styled.div`
  display: grid;

  grid-template-columns: repeat(3, 1fr);

  gap: 18px;

  width: 100%;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;

    max-width: 500px;

    margin: 0 auto;
  }
`

const DocumentoCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  min-height: 0;
  box-sizing: border-box;

  padding: 22px 20px 18px;

  background: #ffffff;

  border: 1px solid rgba(160, 240, 0, 0.35);
  border-radius: 16px;

  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);

  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);

    border-color: #a0f000;

    box-shadow:
      0 12px 30px rgba(0, 0, 0, 0.16),
      0 0 18px rgba(160, 240, 0, 0.12);
  }
`

const PdfIcon = styled.div`
  width: 54px;
  height: 54px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(160, 240, 0, 0.08);

  border: 1px solid rgba(160, 240, 0, 0.45);

  border-radius: 13px;

  color: #8bd600;

  font-size: 25px;

  margin-bottom: 14px;

  transition: all 0.3s ease;

  ${DocumentoCard}:hover & {
    background: #a0f000;
    color: #000000;

    transform: scale(1.05);
  }
`

const DocumentoNombre = styled.h3`
  color: #151515;

  font-family: 'Kobern';
  font-size: 17px;
  font-weight: 600;

  line-height: 1.3;

  text-align: center;

  margin: 0 0 18px;

  min-height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;
`

const DescargarButton = styled.a`
  width: 100%;
  max-width: 210px;

  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 9px;

  padding: 11px 15px;

  background: #a0f000;
  color: #000000;

  border-radius: 7px;

  font-family: 'Kobern';
  font-size: 13px;
  font-weight: 600;

  text-decoration: none;

  transition: all 0.25s ease;

  &:hover {
    background: #000000;
    color: #a0f000;

    transform: translateY(-2px);
  }
`
const DocumentoInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 6px;

  color: #8a8a8a;

  font-family: 'Kobern';
  font-size: 10px;

  margin-top: 9px;
`

const IntensivoDeNavidad = () => {

const documentos = [
  {
    nombre: 'TARIFAS APA 26-27',
    archivo: '/PDF/TARIFAS APA 26-27.pdf'
  },
  {
    nombre: 'NORMATIVA APA 26-27',
    archivo: '/PDF/NORMATIVA APA 26-27.pdf'
  },
  {
    nombre: 'APA Web',
    archivo: '/PDF/APA%20WEB.pdf'
  }
]

  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <FxView />

      <ContainerGeneral>
        <ContainerTexto>

          <TituloGrande>
            Información e inscripción Temporada 26 - 27
          </TituloGrande>

          <ContainerImagenes>
            <Imagen
              src={require('./Escuela de Padel  Bellavista Huelva Club.jpg')}
              alt="Escuela de Padel Bellavista Huelva Club"
            />
          </ContainerImagenes>


          {/* INSCRIPCIÓN */}

          <ButtonContainer>
            <Boton
              href="https://docs.google.com/forms/d/e/1FAIpQLSefdp6ItyK4u6SwghWS3BGy-4Bog4-WdONZ2MfxfgofnoITdQ/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              INSCRIPCIÓN
            </Boton>
          </ButtonContainer>


          {/* DOCUMENTACIÓN */}

          <DocumentosSection>

            <DocumentosTitulo>
              Documentación
            </DocumentosTitulo>

            <DocumentosSubtitulo>
              Consulta y descarga toda la información de la temporada 2026 - 2027
            </DocumentosSubtitulo>

      <DocumentosGrid>

  {documentos.map((documento, index) => (

    <DocumentoCard key={index}>

      <PdfIcon>
        <FontAwesomeIcon icon={faFilePdf} />
      </PdfIcon>

      <DocumentoNombre>
        {documento.nombre}
      </DocumentoNombre>

      <DescargarButton
        href={documento.archivo}
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        <FontAwesomeIcon icon={faDownload} />
        DESCARGAR PDF
      </DescargarButton>

      <DocumentoInfo>
        <FontAwesomeIcon icon={faFileLines} />
        Documento PDF
      </DocumentoInfo>

    </DocumentoCard>

  ))}

</DocumentosGrid>

          </DocumentosSection>

        </ContainerTexto>
      </ContainerGeneral>

      <Footer />

      <></>
    </div>
  )
}

export default IntensivoDeNavidad